﻿﻿export interface IDonorReimbursement {
    id: number;
    donorRegistrationId: number;
    paymentCreatedDateTime: Date;
    paymentDate: Date;
    paymentAmount: number;
}
